// Exception: HOC that proxy down props
/* eslint-disable react/jsx-props-no-spreading */

import { FC, SVGProps } from 'react';

import classes from './Image.module.scss';

const WiringArrowsImage: FC<SVGProps<SVGSVGElement>> = props => (
  // View box is shifted to the left, so the chip is exactly in the center.
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="-40 0 2000 2000" xmlSpace="preserve" {...props}>
    <path className={classes.st0} d="M943.18 1723.97v-92.67" />
    <path className={classes.st6} d="m946.08 1633.28-2.9-10.84-2.91 10.84h5.81z" />
    <path className={classes.st0} d="m998.59 1694.78.13-177.26" />
    <path className={classes.st6} d="m1001.62 1519.5-2.89-10.84-2.92 10.84h5.81z" />
    <path
      className={classes.st0}
      d="M1054 1665.59v-5.76l.28-262.94M1109.42 1636.4v-8.64l.4-262.81M1164.83 1607.21v-11.04l.52-265.89M1220.24 1578.02v-14.4l.68-263.95m55.55 231.87v-264.87M1554.22 1371.19v-264.57M1498.67 1403.26v-265.41M1443.12 1435.33v-264.19M1388.4 1467.39v-264.24M1332.02 1499.47v-264.31"
    />
  </svg>
);

export default WiringArrowsImage;
